import * as yup from 'yup';

export const schema = yup.object({
  code: yup.string().required('El campo es requerido')
});

export { yupResolver } from '@hookform/resolvers/yup';
